module.exports = __webpack_public_path__ + "static/media/home-product-onoiwa.b63b9165.png";